import React from 'react';
import { Star } from 'lucide-react';
const Testimonial = ({
  name,
  location,
  text,
  image
}: {
  name: string;
  location: string;
  text: string;
  image: string;
}) => <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-152">
    <div className="flex items-center gap-1 text-yellow-400 mb-4" data-id="element-153">
      {[1, 2, 3, 4, 5].map(i => <Star key={i} size={16} fill="currentColor" data-id="element-154" />)}
    </div>
    <p className="text-gray-600 italic mb-6 flex-1" data-id="element-155">"{text}"</p>
    <div className="flex items-center gap-4 mt-auto" data-id="element-156">
      <img src={image} alt={name} className="w-12 h-12 rounded-full object-cover border-2 border-[#E8D5D5]" data-id="element-157" />
      <div data-id="element-158">
        <p className="font-bold text-sm text-[#2D3436]" data-id="element-159">{name}</p>
        <p className="text-xs text-gray-500" data-id="element-160">{location}</p>
      </div>
    </div>
  </div>;
export function Testimonials() {
  return <section className="py-16 px-4 bg-white" data-id="element-161">
      <div className="max-w-7xl mx-auto" data-id="element-162">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-[#2D3436] mb-12" data-id="element-163">
          Mujeres reales que transformaron su día a día
        </h2>

        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-164">
          <Testimonial name="Mariana G." location="Buenos Aires" text="Siempre empezaba y dejaba. Con este sistema entendí que no era culpa mía, sino que me faltaba orden. Hoy llevo 45 días seguidos." image="https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1000&auto=format&fit=crop" data-id="element-165" />
          <Testimonial name="Silvina R." location="Córdoba" text="Los dolores de espalda por la oficina eran insoportables. Las rutinas de Yoga Terapéutico me salvaron la vida." image="https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?q=80&w=1000&auto=format&fit=crop" data-id="element-166" />
          <Testimonial name="Valeria M." location="Rosario" text="Lo mejor es que no te sentís presionada. Es como tener una amiga que te guía paso a paso. El diario de práctica es hermoso." image="https://images.unsplash.com/photo-1595956553066-fe24a8c33395?q=80&w=1000&auto=format&fit=crop" data-id="element-167" />
          <Testimonial name="Andrea P." location="Mendoza" text="Compré el combo profesional porque quiero enseñar. El material es completísimo y muy claro. Vale cada peso." image="https://images.unsplash.com/photo-1554151228-14d9def656ec?q=80&w=1000&auto=format&fit=crop" data-id="element-168" />
          <Testimonial name="Julieta S." location="La Plata" text="Nunca pensé que podría hacer yoga en casa y ser constante. Las rutinas express son ideales para cuando tengo poco tiempo." image="https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1000&auto=format&fit=crop" data-id="element-169" />
        </div>
      </div>
    </section>;
}